/**
 * Dependencies.
 */
import { BaseModel, endpoint, prop } from '@prz-dp/services';

/**
 * Model `AddressCoordinatesModel`.
 */
@endpoint('address/coordinates')
export default class AddressCoordinatesModel extends BaseModel {
  /**
   * Properties.
   */
  @prop()
  addresses: {
    additionalInformation?: string;
    city?: string;
    countryCode?: string;
    countryName?: string;
    doorNumber?: number;
    latitude?: number;
    longitude?: number;
    street?: string;
    zipCode?: string;
  }[];

  /**
   * Constructor.
   */
  constructor(data: Partial<AddressCoordinatesModel>) {
    super(data);
  }
}
